import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import LoadingSpinner from '../partials/LoadingSpinner';

import { updateSelectedItems } from '../../redux/actions/products';
import { assignmentsByItem } from '../../redux/actions/assignments';

import EditAssignmentModal from './EditAssignmentModal';
import DeleteAssignmentModal from './DeleteAssignmentModal';

const ItemLine = ({ 
  payload, 
  settings, 
  sku, 
  upc, 
  brand, 
  productId, 
  itemId, 
  smallThumbnailUrl, 
  options, 
  name, 
  selectedProductList, 
  setSelectedProductList, 
  products, 
  downloadUrl, 
  type, 
  rowId, 
  quantity, 
  price,
  inStockFilter, 
  assignments,
  getAssignments,
  supplierPrice,
  setSupplierPrice,
  minOrder,
  setSupplierMinOrder,
  setSupplierSku,
  supplierSku,
  orderMultiple,
  packQuantity,
  setOrderMultiple,
  setPackQuantity,
  submitted,
  supplierId,
  accountUnits,
}) => {
  const [activeAssignment, setActiveAssignment] = useState(null);
  const [showEditAssignmentModal, setShowEditAssignmentModal] = useState(false);
  const [showDeleteAssignmentModal, setShowDeleteAssignmentModal] = useState(false);
  const [modalY, setModalY] = useState(0);

  const [lineAssigned, setLineAssigned] = useState(false);
  let section = !!options ? selectedProductList.variations : selectedProductList.products;
  let inList = Object.keys(section).indexOf(String(itemId)) > -1;

  useEffect(() => {
    if(type === 'variation') {
      getAssignments(payload, supplierId, productId, itemId);
    } else {
      getAssignments(payload, supplierId, productId, null);
    }
  }, []);

  useEffect(() => {
    if((type === 'variation') && assignments.itemAssignments[`${productId}/${itemId}`]) {
      setLineAssigned(assignments.itemAssignments[`${productId}/${itemId}`].find(assignment => assignment?.supplier_id === supplierId));
    }

    if((type === 'product') && assignments.itemAssignments[`${productId}/null`]) {
      setLineAssigned(assignments.itemAssignments[`${productId}/null`].find(assignment => assignment?.supplier_id === supplierId));
    }
  }, [assignments]);


  const showEditModal = (event) => {
    console.log(lineAssigned);
    setModalY(event.pageY);

    let assignment = lineAssigned.body;
    assignment.product_id = productId;
    if(type === 'variation') { assignment.variation_id = itemId; }

    setActiveAssignment(assignment);
    setShowEditAssignmentModal(true);
  }

  const showDeleteModal = (event) => {
    setModalY(event.pageY);
    
    let assignment = lineAssigned.body;
    assignment.product_id = productId;
    // assignment.variation_id = itemId;
    if(type === 'variation') { assignment.variation_id = itemId; }

    setActiveAssignment(assignment);
    setShowDeleteAssignmentModal(true);
  }

  const switchSelection = () => {
    if (inList) {
      delete section[itemId];
    } else {

      section[itemId] = {
        sku: sku,
        upc: upc,
        brand: brand,
        smallThumbnailUrl: smallThumbnailUrl,
        options: options,
        name: name,
        quantity: quantity,
        price: price,
        productId: productId,
      };
    }

    setSelectedProductList({ ...selectedProductList });
  };

  const setAssignmentValue = (itemId, type, e, setter) => {
    section[itemId] = {
      sku: sku,
      upc: upc,
      brand: brand,
      smallThumbnailUrl: smallThumbnailUrl,
      options: options,
      name: name,
      quantity: quantity,
      price: price,
      productId: productId,
    };

    setSelectedProductList({ ...selectedProductList });
    setter(itemId, type, e);

    if (e.target.value) {
      e.target.parentElement.classList.add("field--filled");
    } else {
      e.target.parentElement.classList.remove("field--filled");
    }
  }

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }


  if(inStockFilter && !quantity) {
    return(
      <></>
    )
  }

  return(
    <div className="list-element list-element--normal list-element--has-hover">
      { !lineAssigned &&
        <div className="list-element__toggle">
          <input type="checkbox" value="on" checked={inList ? 'checked' : ''} id={itemId} tabindex="0" className="list-element__toggle-checkbox" onClick={() => switchSelection()}>
          </input>
          <label for={itemId} className="list-element__toggle-label">
          </label>
        </div>
      }
      <div className="list-element__image">
        { smallThumbnailUrl && <img src={smallThumbnailUrl} /> }
        { !smallThumbnailUrl && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123 123"><g stroke="#c2cbd3" stroke-miterlimit="10"><path fill="#fff" stroke-linecap="round" stroke-linejoin="round" d="M77.46 22.7H48.28l2.02-7.04h25.15zm0 43.26H48.28l2.02 7.05h25.15z"/><path fill="#edeff2" d="M52.63 7.59h20.48v74.29H52.63z"/><path fill="#fff" stroke-linecap="round" stroke-linejoin="round" d="M91.903 39.907v8.59h-3.82v-8.59z"/><ellipse cx="63.08" cy="44.21" fill="#fff" stroke-linecap="round" stroke-linejoin="round" rx="25.76" ry="25.53"/><g fill="#fff" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="63.08" cy="44.13" rx="21.8" ry="21.6"/><path d="M51.34 33.05l11.91 11.24 7.47-3.93"/><ellipse cx="63.08" cy="44.13" rx="1.78" ry="1.76"/></g></g></svg> }
      </div>
      <div className="list-element__content">
        <div className="list-element__info">
          <div className="list-element__header">
            <div className="list-element__main-info">
              <div className="list-element__title"><span>{name}</span></div>
            </div>
          </div>
          <div className="list-element__data-row">

          </div>
          <div className="list-element__data-row">
            <ul>
              { options && options.map(option =>
                  <li>
                    <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                  </li>
                )
              }
              { quantity && 
                <li>In Stock: <span className="inline-text-tag inline-text-tag--light-half">{ quantity }</span></li>
              }
              { brand &&
                <li>Brand: <span className="inline-text-tag inline-text-tag--light-half">{ brand }</span></li>
              }
              { price &&
                <li>Price: <span className="inline-text-tag inline-text-tag--light-half">{ format(price) }</span></li>
              }
              { !options &&
                <div className="text-default warning">
                  Base Product
                </div>
              }
            </ul>
          </div>
        </div>

        <div className="list-element__actions">
          { assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) &&
            <LoadingSpinner
              statusText="Loading Assignments"
            />
          }

          { lineAssigned &&
            <>
              <div className="flex-1">
                <div className="left-15">
                  <h4>Assignment Details</h4>
                  <ul>
                    <li>Supplier SKU: <span className="inline-text-tag">{lineAssigned.body.supplier_sku || "Not set"}</span></li>
                    <li>Supplier Price: <span className="inline-text-tag">{lineAssigned.body.supplier_price ? format(lineAssigned.body.supplier_price) : "Not set"}</span></li>
                    <li>MOQ: <span className="inline-text-tag">{lineAssigned.body.minimum_order || "Not set"}</span></li>
                    { settings?.order_multiples && 
                      <li>Order Multiple: <span className="inline-text-tag">{lineAssigned.body.order_multiple || "Not set"}</span></li>
                    }
                    { settings?.pack_quantities && 
                      <li>Pack Quantity: <span className="inline-text-tag">{lineAssigned.body.pack_quantity || "Not set"}</span></li>
                    }


                  </ul>
                </div>
              </div>
              <div className="flex-1">
                <button
                  className={`btn btn-default ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`) ? 'btn-loading' : ''}`}
                  onClick={(event) => showEditModal(event)}
                  disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M5.0355 15.7929 2.207 12.9645 1.5 16.5l3.5355-.7071z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8136.9437c.3906-.3905 1.0237-.3905 1.4143 0l2.8284 2.8284c.3905.3905.3905 1.0237 0 1.4142L5.5285 16.7141.2252 17.7748l1.0606-5.3033L12.8136.9437zm.7072 2.1213-9.8995 9.8995 1.4142 1.4142 9.8995-9.8995-1.4142-1.4142zM3.0071 15.1788l-.186-.186-.0464.2325.2324-.0465z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Edit Assignment</span>
                </button>
                <br/>
                <br/>
                <button
                  className={`btn btn-default btn--destructive ${assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`) ? 'btn-loading' : ''}`}
                  onClick={(event) => showDeleteModal(event)}
                  disabled={submitted || assignments.updatingAssignments.find(assignmentId => assignmentId === `${productId}/${itemId}`)}
                >
                  <span className="svg-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M7 0h4l1 2H6l1-2z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2 3c-.5523 0-1 .4477-1 1s.4477 1 1 1v11c0 1.1046.8954 2 2 2h10c1.1046 0 2-.8954 2-2V5c.5523 0 1-.4477 1-1s-.4477-1-1-1H2zm12 13V5H4v11h10z"/><path d="M6 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6zM10 7.5c0-.5523.4477-1 1-1s1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6z"/></svg>
                  </span>
                  <span className="gwt-InlineLabel">Remove Assignment</span>
                </button>
              </div>
            </>
          }
          { !lineAssigned && !assignments.itemSearchingAssignments.find(item => item === `${productId}/${itemId}`) &&
            <div className="fieldset">
              <div className="field field--medium">
                <label className="field__label">Supplier SKU &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierSku)}
                  value={supplierSku}
                  type="text"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">Supplier SKU</div>
              </div>

              <div className="field field--medium">
                <label className="field__label">Supplier Price &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierPrice)}
                  value={supplierPrice}
                  type="number"
                  min="0"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">Supplier Price</div>
              </div>
              <div className="field field--medium">
                <label className="field__label">Minimum Order Quantity &nbsp;&nbsp;</label>
                <input
                  required
                  onChange={(e) => setAssignmentValue(itemId, type, e, setSupplierMinOrder)}
                  value={minOrder}
                  type="number"
                  min="0"
                  disabled={submitted}
                  className="field__input"
                />
                <div className="field__placeholder">MOQ</div>
              </div>

              { settings?.order_multiples && 
                <div className="field field--medium">
                  <label className="field__label">Order Multiple &nbsp;&nbsp;</label>
                  <input
                    required
                    onChange={(e) => setAssignmentValue(itemId, type, e, setOrderMultiple)}
                    value={orderMultiple}
                    type="number"
                    min="0"
                    disabled={submitted}
                    className="field__input"
                  />
                  <div className="field__placeholder">Order Multiple</div>
                </div>
              }

              { settings?.pack_quantities && 
                <div className="field field--medium">
                  <label className="field__label">Pack Quantity &nbsp;&nbsp;</label>
                  <input
                    required
                    onChange={(e) => setAssignmentValue(itemId, type, e, setPackQuantity)}
                    value={packQuantity}
                    type="number"
                    min="0"
                    disabled={submitted}
                    className="field__input"
                  />
                  <div className="field__placeholder">Pack Quantity</div>
                </div>
              }

            </div>
          }

        </div>

      </div>


      { showEditAssignmentModal && 
        <EditAssignmentModal
          payload={payload}
          supplierId={supplierId}
          showEditAssignmentModal={showEditAssignmentModal}
          setShowEditAssignmentModal={setShowEditAssignmentModal}
          assignment={activeAssignment}
          assignmentName={name}
          modalY={modalY}
        />
      }

      { showDeleteAssignmentModal &&
        <DeleteAssignmentModal
          payload={payload}
          supplierId={supplierId}
          showDeleteAssignmentModal={showDeleteAssignmentModal}
          setShowDeleteAssignmentModal={setShowDeleteAssignmentModal}
          assignment={activeAssignment}
          assignmentName={name}
          modalY={modalY}
        />
      }
    </div>
  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  settings: state.settings.settings,
  selectedProductList: state.products.selectedProductList,
  products: state.products,
  assignments: state.assignments,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedProductList: (items) => dispatch(updateSelectedItems(items)),
  getAssignments: (payload, supplierId, productId, variationId) => dispatch(assignmentsByItem(payload, supplierId, productId, variationId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemLine);
